import { ModuleWithProviders, NgModule } from '@angular/core'
import {
  ConfigInitializer,
  CONFIG_INITIALIZER,
  I18nConfig,
  provideDefaultConfig,
  TranslationService
} from '@spartacus/core'
import { ebI18nConfig } from './config/eb-i18n-config'
import { EbI18nConfigInitializer } from './config/eb-i18n-config-initializer.service'
import { EbI18nextTranslationService } from './i18next'
import { ebI18nextProviders } from './i18next/eb-i18next-providers'

export function initI18nConfig(
  configInitializer: EbI18nConfigInitializer,
  config: I18nConfig
): ConfigInitializer | null {
  /**
   * If `fallbackLang` was already configured statically
   */
  if (config?.i18n?.fallbackLang !== undefined) {
    return null
  }
  return configInitializer
}

@NgModule({})
export class EbI18nModule {
  static forRoot(): ModuleWithProviders<EbI18nModule> {
    return {
      ngModule: EbI18nModule,
      providers: [
        provideDefaultConfig(ebI18nConfig),
        { provide: TranslationService, useExisting: EbI18nextTranslationService },
        ...ebI18nextProviders,
        {
          provide: CONFIG_INITIALIZER,
          useFactory: initI18nConfig,
          deps: [EbI18nConfigInitializer, I18nConfig],
          multi: true
        }
      ]
    }
  }
}
